import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ProduitService } from '../../types';
import { produitServiceService } from '../../services/produitService';

interface ProduitsState {
  list: ProduitService[];
  loading: boolean;
}

const initialState: ProduitsState = { list: [], loading: false };

export const fetchProduits = createAsyncThunk('produits/fetchAll', () => produitServiceService.getAll());

const produitsSlice = createSlice({
  name: 'produits',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProduits.pending, (state) => { state.loading = true; })
      .addCase(fetchProduits.fulfilled, (state, action: PayloadAction<ProduitService[]>) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchProduits.rejected, (state) => { state.loading = false; });
  },
});

export default produitsSlice.reducer;
